import { render, staticRenderFns } from "./ticketPurchases.vue?vue&type=template&id=032d2d99&scoped=true&"
import script from "./ticketPurchases.vue?vue&type=script&lang=js&"
export * from "./ticketPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d2d99",
  null
  
)

export default component.exports